<template>
  <div>
   <!-- <a-drawer width="65vw" placement="left" :closable="false" :visible="ismodeltab" @close="onClose"
    :wrapStyle="{padding:'0'}"  id='myleftmenu'> -->
    <transition name="slide-fade">
        <div class='mode_body' v-if='ismodeltab' style="overflow-y: auto;"  id='warp_screen'>
          <div class='firts_div' style="border-bottom: 1px solid #ccc;">
            <img :src="require('@/image/home_model/logo.png')" alt="" style="width: 8rem;margin-left: .5rem;">
            <!-- <div style="display: flex;justify-content: space-between;
            align-items: center;padding: 10px 0;"><img :src="require('@/image/meunleft/lang.png')" alt="" class='myis_img'
            style="position: relative;top:-.5px;margin: 0;">
            <span @click='handleMenuClick({name:"CN"})' style="color: #09666E;">{{iskey}}</span>
            </div> -->
            <img :src="require('@/image/home_model/outlogo.png')" alt="" style='width: 1rem;margin-right: .5rem;'
             @click='$emit("child",false)'>
            <!-- <a-icon type="close" style='font-size: 1.3rem;margin-right: .5rem;color: #999999;'
             @click='$emit("child",false)'/> -->
          </div>
          <div id="my_text">
            <div class='isdiv_a' style="position: relative;border-bottom: 1px solid #ccc;margin: 0 14px;" v-if='!isif'>
              <div style="display: flex;align-items: center;color: #09666E;padding: 10px 0;"
              @click='isand = !isand'>
              <img :src="require('@/image/meunleft/srean.png')" alt="" class='myis_img'
               style="position: relative;top: -1px;">{{$lang.inSearch}}
              </div>
              <div class='warp_input' v-if='isand'>
              <input type="text" class='mput' v-model="qvalue" :placeholder="$lang.inSearch">
              <a-icon type="search" style='font-size: 18px;' @click='handval'/>
              </div>
              <div style="display: flex;justify-content: space-between;
              align-items: center;padding: 10px 0;"><img :src="require('@/image/meunleft/lang.png')" alt="" class='myis_img'
              style="position: relative;top:-.5px;margin: 0;">
              <span @click='handleMenuClick({name:"CN"})' style="color: #09666E;">{{iskey}}</span>
              </div>
              </div>

              <div style="padding: 12px 10px;background: #f7f7f7;"
              v-if='isif' @click='isif = false'>
              <a-icon type="left" style='margin-left: 5px;color: #666;margin-right: 10px;'/>
              <span style='color: #09666E;'>{{shouyelist[1][islang=="eng"?'en_name':'name']}}</span>
              </div>
              <transition name="slide-fade_w">
              <div v-if='isif' style="background: #f7f7f7;border-bottom: 1px solid #e5e5e5;">
                <div v-for='(ev,a) in fchild' v-if='isif'
                  style="padding-left: 0;margin: 0 0 0 46px;
    border-top: 1px solid #e5e5e5;" @click='openurlfn(ev.url)'>
                  {{islang=="eng"?ev.en_name:ev.name}}</div>
              </div>
              </transition>
              <div v-show='!isif' style="border-bottom: 1px solid #e5e5e5;">
                <div v-for='(val,ind) in shouyelist' :key='ind+"007700"'
                :class='handnum===ind?"issecode":""'>
                <div class='isdiv_a' @click='openurl(ind)'>
                  <div style="display: flex;align-items: center;justify-content: flex-start;">
                    <img :src="handnum===ind?val.imgurl1:val.imgurl" alt="" class='myis_img'>
                    <!-- <span v-if='(handnum == 1)||(handnum ==3)'></span> -->
                    <span :style="{color: handnum===ind?'#09666E':''}">{{islang=="eng"?val.en_name:val.name}}</span>
                  </div>
                  <div v-if='ind==1||ind==3'>
                     <img :src="handnum===ind?require('@/image/meunleft/up.png'):require('@/image/meunleft/down.png')"
                     alt="" style='position: relative;top: -2px;' width="16px">
                    </div>
                </div>
                  <div v-if='handnum===ind'>
                    <div v-for='(items,inds) in ischild' :key='inds+"2022"'
                     @click='inds==2?isif=!isif:openurlfn(items.url)' class='mybotom' v-if='handnum ==1'>
                      <div style="display: flex;justify-content: space-between;"
                      :style='{color:items.child&&isif?"#09666E":""}'>
                        {{islang=="eng"?items.en_name:items.name}}
                        <div v-if='items.child' >
                          <img :src="isif?require('@/image/meunleft/up.png'):require('@/image/meunleft/down.png')" alt=""
                           style='position: relative;top: -2px;transform: rotate(-90deg);' width="16px">
                         </div>
                      </div>

                    </div>
                    <div v-for='(items,inds) in ischanpian' :key='inds+"2022"' @click='openurlfn(items.url)'
                      class='mybotom' v-if='handnum ==3'>
                      <div>{{islang=="eng"?items.en_name:items.name}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-for='(v,i) in params' v-if='i<5' :key='i+"params"'
               @click='openurlfn(v.url)' class="bottom_div">{{v.text}}</div>
              <br>
          </div>
        </div>
        <!-- </a-drawer> -->
    </transition>

    <div style="width: 35%;z-index: 200;background-color: rgba(0,0,0,.45);position: fixed;height: 100vh;
    right: 0;top: 3.1rem;" v-if='ismodeltab' @click="$emit('child',false)"></div>
  </div>
</template>

<script>
  export default{
    props:['shouyelist','ismodeltab'],
    data(){
      return{
        qvalue:'',
        params:[],
        isabc:false,
        iskey:'EN',
        isand:false,
        isif:false,
        handnum:'',
        onlinestate:sessionStorage['onlinestate'],
        islang: window.localStorage.guanwanglang,
        ischanpian:[
          {name:'開立帳戶',url:'/apply_in_person_individual',en_name:'Account Opening'},
          {name:'數據服務',url:'/market_data',en_name:'Market Data Service'},
          {name:this.$lang.zjcq,url:'/deposit&withdrawal',en_name:this.$lang.zjcq},//
          {name:this.$lang.bgxz,url:'/download_form',en_name:this.$lang.bgxz},
          {name:this.$lang.cjwt,url:'/FAQs',en_name:this.$lang.cjwt},//
          {name:this.$lang.gzjq,url:'/market_holiday',en_name:this.$lang.gzjq},
          {name:this.$lang.jytg,url:'/trading_announcement',en_name:this.$lang.jytg},
          ],
          fchild:[
            {name:'美股',url:'/ussecurities_introduction',en_name:'US Stocks'},
            {name:'日股',url:'/jpsecurities_introduction',en_name:'Japan Stocks'},
            {name:'台股',url:'/twsecurities_introduction',en_name:'Taiwan Stocks'},
            {name:'澳洲股',url:'/ausecurities_introduction',en_name:'Australia Stocks'},
            {name:'新加坡股',url:'/sgsecurities_introduction',en_name:'Singapore Stocks'},
            {name:'馬來西亞股',url:'/mysecurities_introduction',en_name:'Malaysia Stocks'},
            {name:this.$lang.d_g,url:'/gesecurities_introduction',en_name:this.$lang.d_g},
            // {name:'滬港深通',url:'/stockconnect_introduction',en_name:'Shanghai-HK Stocks'},
          ],
        ischild:[
          {
            name:'香港證券',
            en_name:'Hong Kong Securities',
            url:'/hksecurities_introduction'
          },
          {
            name:'滬深港通',
            en_name:'Securities Transfer',
            url:'/stockconnect_introduction'
          },
          {
            name:'環球證券',
            en_name:'Global Securities',
            // url:'/ussecurities_introduction'
            child:[
              {name:'美股',url:'/ussecurities_introduction',en_name:'US Stocks'},
              {name:'日股',url:'/jpsecurities_introduction',en_name:'Japan Stocks'},
              {name:'台股',url:'/twsecurities_introduction',en_name:'Taiwan Stocks'},
              {name:'澳洲股',url:'/ausecurities_introduction',en_name:'Australia Stocks'},
              {name:'新加坡股',url:'/sgsecurities_introduction',en_name:'Singapore Stocks'},
              {name:'馬來西亞股',url:'/mysecurities_introduction',en_name:'Malaysia Stocks'},
              {name:'德股',url:'/gesecurities_introduction',en_name:'Germany Stocks'},
              // {name:'滬港深通',url:'/stockconnect_introduction',en_name:'Shanghai-HK Stocks'},
            ]
          },
          {
            name:this.$lang.zcgl,
            en_name:this.$lang.zcgl,
            url:'/asset_management_introduction'
          },
          {
            name:'債券服務',
            en_name:'Bonds Services',
            url:'/bonds_introduction'
          },
          {
            name:'基金服務',
            en_name:'Fund Services',
            url:'/fund_introduction'
          },

          {
            name:'證券轉倉',
            en_name:'Stock Transfer',
            url:'/securities_transfer'
          }
        ],
      }
    },
    watch: {
      ismodeltab:{
        handler(ev) {
          if(ev){
            // this.isabc=false
            // setTimeout(()=>{
            //   this.isabc=true
            // },300)
          }
        }
      }
    },
    mounted() {
      if(window.localStorage.guanwanglang){
        this.iskey = window.localStorage.guanwanglang=='eng'?'中文':'EN'
      }
      this.getdate()
    },
    methods:{
      handval(){
        if(this.qvalue){
          this.$router.push({
            path:'/sreachpage',
            query:{
              value:this.qvalue
            }
          })
        }
      },
      getdate() {
        this.$ajax({
          method: 'post',
          url: this.$api.getGroupMenu,
        }).then(res => {
          let arr = res.data.groupMenuList.reverse();
          for(let a = 0;a<5;a++){
            this.params.unshift(arr[a])
          }
        })
      },
      onClose(){
        this.$emit("child",false)
      },
      handleMenuClick(val) {
           if(window.localStorage.guanwanglang=='eng'){
             // window.localStorage.guanwanglang = ''
             window.localStorage.guanwanglang = 'big5'
           }else{
             // window.localStorage.guanwanglang = ''
             window.localStorage.guanwanglang = 'eng'
           }
           setTimeout(()=>{
             location.href = location.href.split('?lang=')[0]
             // location.reload();
           },200)
      },
      openurlfn(val){
        if(!val.child){
        let arr = location.pathname.split('/')
        let str = arr[arr.length-1]
        // let str = location.pathname.split('/qmisgroup')[1]
         str = str.split('?')[0]
        if(('/'+str)==val){
          this.$emit("child" , false);
        }
         if (val) {
          this.$router.push(val)
        }
        }
      },
      postdata(){
        this.$ajax({
          method:'post',
          url:this.$api.yuyuekaihu
        }).then(res=>{
          if(res.data.qmiscode === 1000){
          }else{
            this.$message.warning(res.data.qmismsg)
          }
        })
      },
      zaixiankaihu(){
        this.$ajax({
          method:'post',
          url:this.$api.zaixiankaihu
        }).then(res=>{
          if(res.data.qmiscode === 1000){
          }else{
            this.$message.warning(res.data.qmismsg)
          }
        })
      },
      openurl(i){
        if (i == 4) {
          this.postdata()
        }
        if (i == 5) {
          this.zaixiankaihu()
        }
        if(this.handnum === i){
          this.handnum = ''
        }else{
          this.handnum = i
          if(i!==1&&i!==3){
            this.handnum = ''
            if (this.shouyelist[i]['url'].split('http').length>1) {
              if (this.onlinestate == 'ipad' && i == 5) {
                window.open(this.shouyelist[i]['url'])
              }else{

                window.open(this.shouyelist[i]['url'] + window.localStorage.guanwanglang)
              }
             } else if (this.shouyelist[i]['url']) {
				let arr = location.pathname.split('/')
				let str = arr[arr.length-1]
                str = str.split('?')[0]
               if(('/'+str) == this.shouyelist[i]['url']){
                 this.$emit("child" , false);
               }
               this.$router.push(this.shouyelist[i]['url'])
             }
          }else{
            setTimeout(()=>{
              document.getElementById('warp_screen').scrollTop = i==1?150:230
            },100)
          }
        }
      }
    }
  }
</script>
<style>
  #myleftmenu .ant-drawer-body{
    padding: 0;
  }
</style>
<style scoped>
  .mput{
    border: 1px solid #fff;
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
    width: 100%;
    border-radius: 0;
    outline: none;
  }
  .mput:hover{
    border-bottom: 1px solid #09666E;
  }
  .bottom_div{
    color: #09666E;
    /* padding-top: ; */
    margin: 15px 0px 10px 13px;
    font-size: 15px;
    font-weight: 600;
  }
  .warp_input{
    position: absolute;
    left:0;
    top: 40px;
    background: #fff;
    width: 100%;
    -webkit-box-shadow: 0 3px 10px rgb(0 0 0 / 25%);
    box-shadow: 0 3px 10px rgb(0 0 0 / 25%);
    padding: 5px;
    border-radius: 4px;
    display: flex;
    align-items:center;
    justify-content: space-between;
  }
  .lang_en{
    border-bottom: 1px solid #000;
  }

  .myis_img{
      width: 24px;
      margin-right: 10px;
  }
  .mybotom{
    /* border-bottom: 1px solid #ccc; */
    padding-top: 12px;
    margin: 12px 0 7px 36px;
    border-top: 1px solid #e5e5e5;
  }
  .issecode{
    /* border-left: 3px solid #09666E; */
    background: #f7f7f7;
    border-bottom: 1px solid #e5e5e5;
  }
  .firts_div{
    padding: 0.3rem 0;
    /* border-bottom: 1px solid #ccc; */
    /* border-top: 1px solid #ccc; */
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 5px;
  }
  /* 可以设置不同的进入和离开动画 */
  /* 设置持续时间和动画函数 */
  .slide-fade-enter-active {
    transition: all .2s ease;
  }

  .slide-fade-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active 用于 2.1.8 以下版本 */ {
    transform: translateX(-100%);
    transition: all .2s ease;
  }

  .slide-fade_w-enter-active {
    transition: all .2s ease;
  }

  .slide-fade_w-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade_w-enter, .slide-fade_w-leave-to
  /* .slide-fade-leave-active 用于 2.1.8 以下版本 */ {
    transform: translateX(100%);
    transition: all .2s ease;
  }

  .mode_body{
    width: 65%;
    z-index: 200;
    background-color: #fff;
    /* border-top: 3px solid #09666E; */
    position: fixed;
    height: calc(100vh);
    top: 0;
  }
  .mytitle{
    text-align: center;
    position: relative;
    font-size: 16px;
  }
  .mytitle div{
    color: #307c83;
    display: inline-block;
    margin: 0 auto;
    font-weight: 600;
  }

  #my_text>div>div{
    padding: 12px 10px;
  }

  #my_text{
    position: relative;
  }

  #my_text .isdiv_a{
    /* border-bottom: 1px solid #fff; */
    font-size: 16px;
    color: #000;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/modeltab/mod_right.vue